module.exports = __webpack_public_path__ + "img/IMG_2671_L_BlackMatted.a5f4f880.jpg";